import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import styles from '../Boat.module.scss';
import metadata from './NavigationComponent.metadata.json5';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function NavigationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('NavigationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)

    modelVM.value.isValidationReq = true;

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        ifYesDesNavLimReqFie: {
            visible: !_.isUndefined(modelVM.wilYouUseTheBoaOutLocFie.value) && modelVM.wilYouUseTheBoaOutLocFie.value === true
        },
        formAK1: {
            visible: !_.isUndefined(modelVM.forAK1RevJan28201NAK1Fie.value) && modelVM.forAK1RevJan28201NAK1Fie.value === true
        },
        formBC1: {
            visible: !_.isUndefined(modelVM.forBC1RevOct29201NBC1Fie.value) && modelVM.forBC1RevOct29201NBC1Fie.value === true
        },
        formBC2: {
            visible: !_.isUndefined(modelVM.forBC2RevOct29201NBC2Fie.value) && modelVM.forBC2RevOct29201NBC2Fie.value === true
        },
        formBC3: {
            visible: !_.isUndefined(modelVM.forBC3RevOct29201NBC3Fie.value) && modelVM.forBC3RevOct29201NBC3Fie.value === true
        },
        formBC4: {
            visible: !_.isUndefined(modelVM.forBC4RevOct29201NBC4Fie.value) && modelVM.forBC4RevOct29201NBC4Fie.value === true
        },
        formEC1: {
            visible: !_.isUndefined(modelVM.forEC1RevOct29201NEC1Fie.value) && modelVM.forEC1RevOct29201NEC1Fie.value === true
        },
        formEXT1: {
            visible: !_.isUndefined(modelVM.forEXTRevJan28201NExtFie.value) && modelVM.forEXTRevJan28201NExtFie.value === true
        },
        formEXT1WS: {
            visible: !_.isUndefined(modelVM.forEXTRevJan18201NExtFie.value) && modelVM.forEXTRevJan18201NExtFie.value === true
        },
        formMX1: {
            visible: !_.isUndefined(modelVM.forMX1RevJan18201NLimFie.value) && modelVM.forMX1RevJan18201NLimFie.value === true
        },
        formMX2: {
            visible: !_.isUndefined(modelVM.forMX2RevJan18201NLimFie.value) && modelVM.forMX2RevJan18201NLimFie.value === true
        },
        formON1: {
            visible: !_.isUndefined(modelVM.forON1RevOct29201NON1Fie.value) && modelVM.forON1RevOct29201NON1Fie.value === true
        },
        formOTFLA2: {
            visible: !_.isUndefined(modelVM.forOTFRevOct24201NLimFie.value) && modelVM.forOTFRevOct24201NLimFie.value === true
        },
        formOTFLA: {
            visible: !_.isUndefined(modelVM.forOTFLARevJan18201NLimFie.value) && modelVM.forOTFLARevJan18201NLimFie.value === true
        },
        formOTFLAB: {
            visible: !_.isUndefined(modelVM.forOTFLABRevJan18201NLimFie.value) && modelVM.forOTFLABRevJan18201NLimFie.value === true
        },
        formOTFLAC: {
            visible: !_.isUndefined(modelVM.forOTFRevJan18201NLimFie.value) && modelVM.forOTFRevJan18201NLimFie.value === true
        },
        formOTIEUSA: {
            visible: !_.isUndefined(modelVM.forOTIEUSARevOct24201NUSAFie.value) && modelVM.forOTIEUSARevOct24201NUSAFie.value === true
        },
        formOTIWUSA: {
            visible: !_.isUndefined(modelVM.forOTIRevOct24201NUSAFie.value) && modelVM.forOTIRevOct24201NUSAFie.value === true
        },
        formQC1: {
            visible: !_.isUndefined(modelVM.forQC1RevDec19201NQC1Fie.value) && modelVM.forQC1RevDec19201NQC1Fie.value === true
        },
        formWC1: {
            visible: !_.isUndefined(modelVM.forWC1RevOct29201NWC1Fie.value) && modelVM.forWC1RevOct29201NWC1Fie.value === true
        }
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

NavigationComponent.propTypes = wizardProps;
export default withRouter(NavigationComponent);
